import React, { useState, useEffect } from 'react';

import { toast } from 'react-toastify';
import { LogoutFormInput } from '../../shared/components/LogoutForm/LogoutFormInput';

const LogoutForm = ({ agentQueues = [], isPaused, handleLogoff }) => {
  const [shouldSign, setshouldSign] = useState(null);

  const getQueuesFromAgentSessions = () => {
    return agentQueues.map((session) => session.queue);
  };

  const handleLogout = (data) => {
    const hasSelectedQueues = !!data.queueIds && !!data.queueIds.length;
    if (!hasSelectedQueues) toast.error('Selecione pelo menos uma fila');

    const queuesToRemove = getQueuesFromAgentSessions().filter((f) =>
      data.queueIds.includes(f.id)
    );

    handleLogoff({ queuesToRemove });
  };
  useEffect(() => {
    const shouldsign = localStorage.getItem('should_sign_in_asterisk');
    const shouldsignFormated = JSON.parse(shouldsign);
    setshouldSign(shouldsignFormated);
  }, []);

  return (
    <LogoutFormInput
      handleLogout={handleLogout}
      shouldSign={shouldSign}
      queues={getQueuesFromAgentSessions()}
      isPaused={isPaused}
    />
  );
};

export default LogoutForm;
